// material-ui
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export default function LogoMain() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.2,
        color: theme.palette.common.white
      }}
    >
      {/* ICON */}
      <svg width="32" height="32" viewBox="0 0 32 32">
        <path
          d="M4.63564 15.8644L6.94797 13.552L6.95038 13.5496H11.3006L9.56969 15.2806L9.12278 15.7275L7.35024 17.5L7.56977 17.7201L17.5 27.6498L27.6498 17.5L25.8766 15.7275L25.7518 15.602L23.6994 13.5496H28.0496L28.052 13.552L29.8644 15.3644L32 17.5L17.5 32L3 17.5L4.63564 15.8644ZM17.5 3L25.8784 11.3784H21.5282L17.5 7.35024L13.4718 11.3784H9.12158L17.5 3Z"
          fill={theme.palette.primary.light}
        />
      </svg>

      {/* TEXT */}
      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          letterSpacing: 0.5,
          color: theme.palette.common.white
        }}
      >
        Admin Panel
      </Typography>
    </Box>
  );
}
